import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ROUTESPATH } from '@core';

@Component({
  selector: 'app-change-password-token',
  templateUrl: './change-password-token.component.html',
  styleUrls: ['./change-password-token.component.scss'],
})
export class ChangePasswordTokenComponent implements OnInit {
  public token: string;
  public isValid;
  public resetForm: boolean = true;

  constructor(private route: ActivatedRoute, private router: Router) {}
  async ngOnInit(): Promise<void> {
    this.route.params.subscribe((params) => (this.token = params['token']));
  }
  next() {
    this.router.navigate([ROUTESPATH.LOGIN]);
  }

  retrying() {
    this.isValid = undefined;
  }
}
